/* CK | Info popup of the print file check (split out of the removed scratch ticket script,
 * Leon 23.10.2026). Loaded on every product page by snippets/ck-datacheck-ui.liquid.
 *
 * - A tap on the info icon (.ck-datacheck__tooltip) opens one centered popup with the heading of the
 *   print file check and the text window.ckDatacheckInfo (per language, set by ck-datacheck-ui.liquid).
 * - Capture phase + preventDefault, because the icon sits inside a <label>: without this a tap would
 *   also select the paid option, and on iOS the label sometimes swallowed the tap.
 * - The popup is built once and reused. snippets/ck-datacheck.liquid adds the team photo and the
 *   button words per language right after it opens.
 */
(function () {
  if (window.__ckDatacheckInfoLoaded) return;
  window.__ckDatacheckInfoLoaded = true;

  function track(name) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ck_cross_sell: 'datacheck' });
    } catch (e) {}
  }

  function infoModal() {
    var m = document.querySelector('[data-ck-info-modal]');
    if (m) return m;
    m = document.createElement('div');
    m.className = 'ck-info-modal';
    m.setAttribute('data-ck-info-modal', '');
    m.hidden = true;
    m.innerHTML = '<div class="ck-info-modal__panel" role="dialog" aria-modal="true">' +
      '<button type="button" class="ck-info-modal__close" data-ck-info-close aria-label="Schließen">✕</button>' +
      '<h3 class="ck-info-modal__title"></h3><p class="ck-info-modal__text"></p>' +
      '<button type="button" class="button button--primary button--full-width" data-ck-info-close>Verstanden</button></div>';
    document.body.appendChild(m);
    return m;
  }

  function closeModal() {
    var m = document.querySelector('[data-ck-info-modal]');
    if (m) m.hidden = true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var tip = t.closest('.ck-datacheck__tooltip');
    if (!tip) return;
    e.preventDefault(); e.stopPropagation();
    var box = tip.closest('.ck-datacheck');
    var m = infoModal();
    var label = box && box.querySelector('.ck-datacheck__label');
    m.querySelector('.ck-info-modal__title').textContent = label ? label.textContent.trim() : '';
    var c = tip.querySelector('.ck-datacheck__tooltip-content');
    m.querySelector('.ck-info-modal__text').textContent = window.ckDatacheckInfo || (c ? c.textContent.trim() : '');
    m.hidden = false;
    track('ck_datacheck_info_opened');
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-ck-info-close]') || t.matches('[data-ck-info-modal]')) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
